import React from 'react';
import PropTypes from 'prop-types';
import AddEditUserModal from './AddEditUserModal';
import { generateComponentDocs, generateStoryDocs } from '../../utils/documentationUtils';

export default {
  title: 'Components/Modals/AddEditUserModal',
  component: AddEditUserModal,
  decorators: [
    (Story) => (
      <div className="w-screen h-screen">
        <Story />
      </div>
    ),
  ],
  parameters: {
    ...generateComponentDocs(
      // What problem does it solve?
      '\nThe `AddEditUserModal` component provides a reusable modal window for adding and editing users.\n\n',
      // When & how to use it?
      '\nUse the `AddEditUserModal` component on the `/admin/users` page by clicking on a user row in the table or the `Invite User` button, as appropriate.\n\n',
      // Current Usage
      `\nThe \`AddEditUserModal\` component is used on the UsersPage. It displays details such as:
      \n- User's first name
      \n- User's last name
      \n- User's email
      \n- User's role\n\n`,
      // Related Components
      `\n- **[CustomSelect](http://localhost:6006/?path=/docs/components-inputs-customselect--docs)**: Similar dropdown component without search functionality.
       \n- **[TextInput](http://localhost:6006/?path=/docs/components-inputs-textinput--docs)**: Simple text input field for forms.\n\n`,
    ),
  },
  tags: ['autodocs'],
  argTypes: {
    handleClose: { action: 'handleClose' },
    userData: { control: { type: 'object' } },
    onSubmit: { action: 'onSubmit' },
    errorMessage: { control: { type: 'object' } },
  },
};

const AddEditUserModalTemplate = (args) => (
  // <div className="flex relative min-h-[750px] max-w-[572px]">
  <AddEditUserModal {...args} />
  // </div>

);

const commonArgs = {
  handleClose: () => {}, // This is just a placeholder function for Storybook.
  onSubmit: () => {}, // This is just a placeholder function for Storybook.
  errorMessage: {
    name_first: 'Please enter the user’s first name',
    name_last: 'Please enter the user’s last name',
    email: 'Please enter the user’s email',
    role: 'Choose a role for this user',
  },
};

export const DefaultModal = AddEditUserModalTemplate.bind({});
DefaultModal.args = {
  ...commonArgs,
};

DefaultModal.parameters = generateStoryDocs(
  // When is this variant used?
  '\nThis variant demonstrates the `AddEditUserModal` component for adding a new user.\n\n',
  // Where is it currently used in the product?
  '\nThe `AddEditUserModal` is available on the `/admin/users` page when clicking the `Invite User` button.\n\n',
);

DefaultModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  errorMessage: PropTypes.shape({
    name_first: PropTypes.string,
    name_last: PropTypes.string,
    email: PropTypes.string,
    role: PropTypes.string,
  }).isRequired,
};

export const EditUserModal = AddEditUserModalTemplate.bind({});
EditUserModal.args = {
  ...commonArgs,
  userData: {
    id: 1,
    name_first: 'John',
    name_last: 'Doe',
    email: 'test@test.com',
    role: 'Planner',
  },
};

EditUserModal.parameters = generateStoryDocs(
  // When is this variant used?
  '\nThis variant demonstrates the `AddEditUserModal` component for editing a user.\n\n',
  // Where is it currently used in the product?
  '\nThe `AddEditUserModal` is available on the `/admin/users` page when clicking on a user row in the table.\n\n',
);

EditUserModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  errorMessage: PropTypes.shape({
    name_first: PropTypes.string,
    name_last: PropTypes.string,
    email: PropTypes.string,
    role: PropTypes.string,
  }).isRequired,
  userData: PropTypes.shape({
    id: PropTypes.number,
    name_first: PropTypes.string,
    name_last: PropTypes.string,
    email: PropTypes.string,
    role: PropTypes.string,
  }).isRequired,
};
